// execute function on DOMContentLoaded
r.ready= function (fn) {
  document.readyState !== 'loading'? fn(): r(document).on('DOMContentLoaded', fn);    
};
